import { useEffect } from "react";
import { useRecoilValue } from "recoil";

import { useStateUnsetter } from "../useStateUnsetter";

import { PageNames } from "@enums";
import { currentPageState } from "@states/pages";
import {
    carDescriptionCatalogValueState,
    carDescriptionDatePurchasedState,
    carDescriptionDateRegistrationState,
    carDescriptionFuelState,
    carDescriptionInvoiceValueState,
    carDescriptionMakeState,
    carDescriptionModelState,
    carDescriptionPowerState,
    carDescriptionVehicleTypeState,
    carDetailsMileageState,
    carDetailsSecurityOptionsState,
    carTypeState,
    driverHistory_LicenseState,
    driverInformationBirthdayState,
    driverInformationCityState,
    driverInformationStreetState,
    insuranceChoiceState,
} from "@states/userData";

export function useStateListener() {
    const page = useRecoilValue(currentPageState);
    const disallowedUnsetPages = [
        PageNames.InsuranceChoice,
        PageNames.AdditionalCovers,
        PageNames.BrokerSearch,
        PageNames.YourInformation,
        PageNames.TechnicalDifficulties,
    ];

    // Unsetter hook
    const {
        unsetInsuranceChoiceState,
        unsetAdditionalCoversState,
        unsetTariffState,
    } = useStateUnsetter();

    // Recoil values
    const carType = useRecoilValue(carTypeState);
    const carDescriptionMake = useRecoilValue(carDescriptionMakeState);
    const carDescriptionModel = useRecoilValue(carDescriptionModelState);
    const carDescriptionVehicleType = useRecoilValue(
        carDescriptionVehicleTypeState,
    );
    const carDescriptionFuel = useRecoilValue(carDescriptionFuelState);
    const carDescriptionPower = useRecoilValue(carDescriptionPowerState);
    const carDescriptionCatalogValue = useRecoilValue(
        carDescriptionCatalogValueState,
    );
    const carDescriptionDateRegistration = useRecoilValue(
        carDescriptionDateRegistrationState,
    );
    const carDescriptionDatePurchased = useRecoilValue(
        carDescriptionDatePurchasedState,
    );
    const carDescriptionInvoiceValue = useRecoilValue(
        carDescriptionInvoiceValueState,
    );
    const carDetailsSecurityOptions = useRecoilValue(
        carDetailsSecurityOptionsState,
    );
    const carDetailsMileage = useRecoilValue(carDetailsMileageState);
    const driverInformationBirthday = useRecoilValue(
        driverInformationBirthdayState,
    );
    const driverInformationStreet = useRecoilValue(
        driverInformationStreetState,
    );
    const driverInformationCity = useRecoilValue(driverInformationCityState);
    const driverHistory_License = useRecoilValue(driverHistory_LicenseState);
    const chosenInsurance = useRecoilValue(insuranceChoiceState);

    // Listeners
    useEffect(() => {
        if (
            page?.name &&
            (!disallowedUnsetPages.includes(page.name as PageNames) ||
                page.name === PageNames.InsuranceChoice)
        ) {
            unsetAdditionalCoversState();
        }
        // eslint-disable-next-line
    }, [chosenInsurance]);

    useEffect(() => {
        if (
            page?.name &&
            !disallowedUnsetPages.includes(page.name as PageNames)
        ) {
            unsetInsuranceChoiceState();
            unsetTariffState();
        }
        // eslint-disable-next-line
    }, [
        carType,
        carDescriptionMake,
        carDescriptionModel,
        carDescriptionVehicleType,
        carDescriptionFuel,
        carDescriptionPower,
        carDescriptionCatalogValue,
        carDescriptionDateRegistration,
        carDescriptionDatePurchased,
        carDescriptionInvoiceValue,
        carDetailsSecurityOptions,
        carDetailsMileage,
        driverInformationBirthday,
        driverInformationStreet,
        driverInformationCity,
        driverHistory_License,
    ]);
}
